import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-view" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "error-message" }
const _hoisted_4 = { class: "button-warp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { title: "使用者登入" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Input, {
        label: "使用者帳號",
        hint: "請輸入帳號",
        onValue: _cache[0] || (_cache[0] = ($event: any) => (_ctx.account = $event))
      }),
      _createVNode(_component_Input, {
        label: "使用者密碼",
        hint: "請輸入密碼",
        type: "password",
        onValue: _cache[1] || (_cache[1] = ($event: any) => (_ctx.password = $event))
      }),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          label: "登入",
          onClick: _ctx.login
        }, null, 8, ["onClick"])
      ])
    ])
  ]))
}